export function debounce(fn, delay) {
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };
}
export function throttle(fn, limit) {
  var throttling = false;
  return function () {
    if (!throttling) {
      throttling = true;
      setTimeout(function () {
        return throttling = false;
      }, limit);
      return fn.apply(void 0, arguments);
    }
  };
}
export function isDesktop() {
  return !/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i.exec(navigator.userAgent);
}
export function isAndroid() {
  var ua = navigator.userAgent.toLowerCase();
  return ua.includes("android");
}
export function getAndroidVersion() {
  var ua = navigator.userAgent.toLowerCase();

  if (ua.indexOf("android") > 0) {
    var _ua$match$, _ua$match;

    var reg = /android [\d._]+/gi; // 得到版本号4.2.2

    var version = "".concat((_ua$match$ = (_ua$match = ua.match(reg)) === null || _ua$match === void 0 ? void 0 : _ua$match[0]) !== null && _ua$match$ !== void 0 ? _ua$match$ : "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, "."); // 得到版本号第一位

    return parseInt(version.split(".")[0]);
  }

  return 0;
}
export function isNotSupportIntersect() {
  if (isAndroid() && getAndroidVersion() < 8) {
    return true;
  }

  return !window.IntersectionObserver;
}
/**
 * detect locale from navigation language
 *
 * @export
 * @param {string} [support=["en", "ja", "zh", "ko", "de", "fr", "es"]]
 * @return {*}
 */

export function getLocale() {
  var support = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["en", "ja", "zh", "ko", "de", "fr", "es"];
  var lang = navigator.language.toLowerCase();

  for (var ix = 0; ix < support.length; ix++) {
    var locale = support[ix];

    if (lang.includes(locale)) {
      return locale;
    }
  }

  return "en";
}